import * as angular from 'angular';
import {IController} from "angular";

export class AccountProvidersTableRowComponent implements IController {
  name: string;
  data: {providerStoreId?: string};
  onRemove: any;
  onEdit: Function;

  /* @ngInject */
  constructor() {

  }

  $onInit() {

  }

  $onChanges(changes) {

  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

}

angular
  .module('bringoz.admin.accounts')
  .component('accountProvidersTableRow', {
    bindings: {
      name: '<',
      data: '<',
      onEdit: '&',
      onRemove: '&',
    },
    template: require('./account-providers-table-row.html').default,
    controller: AccountProvidersTableRowComponent
  });
